import React, { useState, useEffect, useRef } from 'react';
import { Box, Paper, TextField, Typography, Divider } from '@mui/material';
import ScheduledMessageEditor from '../../extension/context/content/components/add-scheduled-message-button/scheduled-message-editor';

export default function EditorPlayground() {
  const [pasteHtml, setPasteHtml] = useState<string>('');
  const [pasteText, setPasteText] = useState<string>('');
  const editorContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handlePaste = (e: ClipboardEvent) => {
      const clipboardData = e.clipboardData;
      if (!clipboardData) return;

      const html = clipboardData.getData('text/html');
      const text = clipboardData.getData('text/plain');
      
      setPasteHtml(html || '(no HTML data)');
      setPasteText(text || '(no text data)');
    };

    // Attach paste listener to the editor container
    const container = editorContainerRef.current;
    if (container) {
      container.addEventListener('paste', handlePaste as any);
    }

    return () => {
      if (container) {
        container.removeEventListener('paste', handlePaste as any);
      }
    };
  }, []);

  return (
    <Box sx={{ 
      display: 'flex', 
      gap: 2,
      minHeight: '100vh', 
      bgcolor: '#f4f6f8',
      p: 2
    }}>
      {/* Editor Panel */}
      <Paper 
        ref={editorContainerRef}
        elevation={3} 
        sx={{ 
          height: '800px', 
          width: 'fit-content',
          display: 'flex', 
          borderRadius: '8px',
          overflow: 'hidden'
        }}
      >
        <ScheduledMessageEditor 
          editorContext="scheduleMessage"
        />
      </Paper>

      {/* Debug Panel */}
      <Paper 
        elevation={3} 
        sx={{ 
          flex: 1,
          maxWidth: '600px',
          p: 2,
          borderRadius: '8px',
          overflow: 'auto'
        }}
      >
        <Typography variant="h6" gutterBottom>
          Paste Debug Info
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Paste text into the editor to see the raw HTML and plain text from the clipboard
        </Typography>

        <Divider sx={{ mb: 2 }} />

        <Typography variant="subtitle2" gutterBottom>
          Plain Text:
        </Typography>
        <TextField
          multiline
          fullWidth
          rows={4}
          value={pasteText}
          variant="outlined"
          sx={{ mb: 2 }}
          InputProps={{
            readOnly: true,
            sx: { fontFamily: 'monospace', fontSize: '12px' }
          }}
        />

        <Typography variant="subtitle2" gutterBottom>
          Raw HTML:
        </Typography>
        <TextField
          multiline
          fullWidth
          rows={15}
          value={pasteHtml}
          variant="outlined"
          InputProps={{
            readOnly: true,
            sx: { fontFamily: 'monospace', fontSize: '12px' }
          }}
        />
      </Paper>
    </Box>
  );
}

